import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IReasonUso } from './interfaces';

export const getReasonUsoList = (data: IDynamicTableParams) => {
  return instance()
    .post<IReasonUso[]>(`/reasonUso/list`, data)
    .then((response) => response.data);
};

export const getReasonUsoListAll = () => {
  return instance()
    .post<IReasonUso[]>('/reasonUso/listAll')
    .then((response) => response.data);
};

export const getReasonUsoListAllNotDeleted = () => {
  return instance()
    .post<IReasonUso[]>('/reasonUso/listAllNotDeleted')
    .then((response) => response.data);
};

export const getReasonUsoAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/reasonUso/availableColumns`)
    .then((response) => response.data);
};

export const getReasonUsoAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/reasonUso/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadReasonUso = (reasonUsoId: number) => {
  return instance()
    .get<IReasonUso>(`/reasonUso/load/${reasonUsoId}`)
    .then((response) => response.data);
};

export const createReasonUso = (reasonUso: IReasonUso) => {
  return instance()
    .post<IReasonUso>('/reasonUso/save', reasonUso)
    .then((response) => response.data);
};

export const updateReasonUso = (reasonUso: IReasonUso) => {
  return instance()
    .post<IReasonUso>(`/reasonUso/${reasonUso.reasonUsoId}/update`, reasonUso)
    .then((response) => response.data);
};

export const archiveReasonUso = (reasonUsoId: number) => {
  return instance()
    .post('/reasonUso/archive', { reasonUsoId })
    .then((response) => response.data);
};

export const recoverReasonUso = (reasonUsoId: number) => {
  return instance()
    .post('/reasonUso/recover', { reasonUsoId })
    .then((response) => response.data);
};
